import React, { CSSProperties } from 'react'
import { lightTheme } from '@/customTheme'

interface PopoverSubheaderProps {
  label: string
  style?: CSSProperties
  capitalize?: boolean
}

function PopoverSubheader({ label, style, capitalize }: PopoverSubheaderProps) {
  const displayLabel = capitalize
    ? label.charAt(0).toUpperCase() + label.slice(1)
    : label

  return (
    <span
      style={{
        ...lightTheme.typography.Small14Bold,
        color: lightTheme.colors.blackGray,
        ...style,
      }}
    >
      {displayLabel}
    </span>
  )
}

export default PopoverSubheader
